import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap5';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import routes from 'app/routes';
import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import { useContext as useUsersContext } from 'components/Users/Context';
import Actions from 'components/Managers/Profile/Actions';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

const transformValues = (enterpriseId, values) => ({
  enterprise_attributes: {
    name: values.legalCompanyName,
    id: enterpriseId,
  },
  first_name: values.first_name,
  last_name: values.last_name,
  email: values.email,
});

export default function Company() {
  const { state } = useLocation();
  const { data } = state || {};

  const { dispatch: dispatchUser, actions: actionsUser, state: stateUser } = useUsersContext();

  const navigate = useNavigate();

  const formSchema = Yup.object().shape({
    first_name: Yup.string().required('First Name is required'),
    last_name: Yup.string().required('Last Name is required'),
    legalCompanyName: Yup.string().required('Legal Company Name is required'),
    email: Yup.string().required('Email is required'),
  });

  const onSubmitHundler = (values, { setSubmitting, setErrors }) => {
    Actions.update(
      stateUser.user.attributes.specific.id,
      transformValues(stateUser.user.attributes.specific.enterprise_id, values),
      false,
      () => {
        setSubmitting(false);
        actionsUser.load(dispatchUser);
        navigate(
          routes.managers.plans.new.plan_details,
          {
            state: {
              data,
            },
          },
        );
      },
      (errors) => {
        const newErrors = {};
        errors.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <Formik
      validationSchema={formSchema}
      enableReinitialize
      initialValues={{
        first_name: stateUser?.user?.attributes?.specific?.first_name,
        last_name: stateUser?.user?.attributes?.specific?.last_name,
        legalCompanyName: stateUser?.user?.attributes?.specific?.enterprise_name,
        email: stateUser?.user?.attributes?.email,
      }}
      onSubmit={onSubmitHundler}
    >
      {({ isSubmitting }) => (
        <FormikForm className="needs-validation" noValidate="">
          <section>
            <Row>
              <Col md={6}>
                <HorizontalTextField name="first_name" label="Your first name" required />
              </Col>

              <Col md={6}>
                <HorizontalTextField name="last_name" label="Your last name" required />
              </Col>

              <Col md={6}>
                <HorizontalTextField name="email" label="Email address" required />
              </Col>

              <Col md={6}>
                <HorizontalTextField name="legalCompanyName" label="Legal company name" required />
              </Col>
            </Row>
          </section>

          <footer className="d-md-flex flex-row-reverse">
            <div className="mb-3 mb-md-0 ms-md-3">
              <Button
                type="submit"
                className="w-100"
                disabled={isSubmitting}
              >
                {isSubmitting && (
                  <LoadingPlaceholder placement="inline" text=" " />
                )}
                Continue
              </Button>
            </div>

            <div className="flex-grow-1 d-flex justify-content-between">
              <Link
                to={routes.managers.plans.new.choose_template}
                className="btn btn-primary btn-reverse"
                state={{ data }}
              >
                Previous
              </Link>

              <Link
                to={routes.managers.policy.index}
                className="btn btn-outline-primary"
                state={{ data }}
              >
                Cancel
              </Link>
            </div>
          </footer>
        </FormikForm>
      )}
    </Formik>
  );
}
